module.exports = __webpack_public_path__ + "img/20190904164242844.9e0aff00.jpg";